import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ConfigurationService } from '../core/configuration.service';

@Injectable({
  providedIn: 'root'        // <--- THE FIX
})
export class GroupLoanMicroFinanceService {
  private baseApiUrl: string;

  constructor(configurationService: ConfigurationService, private httpClient: HttpClient) {
    this.baseApiUrl = configurationService.BaseApiUrl;
  }

  getFiltered(filter: string, pageIndex: number, pageSize: number,
    sortColumn: string, sortAscending: boolean, isMaintenance: boolean = false): Observable<any> {

    const params = {
      filter, pageIndex, pageSize, sortColumn, sortAscending, isMaintenance
    };

    return this.httpClient.post(this.baseApiUrl + 'grouploanmicrofinance/filter', params).pipe(
      map((res: any) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  getAll(): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + 'grouploanmicrofinance').pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  getById(id: number, forMaintenance: boolean = false): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `grouploanmicrofinance/${id}?isMaintenance=${forMaintenance}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  create(groupLoanMicroFinance: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'grouploanmicrofinance', groupLoanMicroFinance).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  update(groupLoanMicroFinance: any): Observable<any> {
    return this.httpClient.put(this.baseApiUrl + `grouploanmicrofinance/${groupLoanMicroFinance.id}`, groupLoanMicroFinance).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  authorise(id: number): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'grouploanmicrofinance/authorise', id).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  delete(id: number): Observable<any> {
    return this.httpClient.delete(this.baseApiUrl + `grouploanmicrofinance/${id}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }
  getSaccoDropdown(): Observable<any> {
  return this.httpClient.get(this.baseApiUrl + 'grouploanmicrofinance/saccodropdown').pipe(
    map((res: Response) => res),
    catchError((err: any) => observableThrowError(err.message || 'Server error')));
}

bulkSaveContributionPayment(payload: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'grouploanmicrofinance/contributionpayment', payload).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error'))
    );
  }

  getStatementFiltered(filter: string, pageIndex: number, pageSize: number,
    sortColumn: string, sortAscending: boolean, isMaintenance: boolean = false): Observable<any> {

    const params = {
      filter, pageIndex, pageSize, sortColumn, sortAscending, isMaintenance
    };

    return this.httpClient.post(this.baseApiUrl + 'grouploanmicrofinance/statement-filter', params).pipe(
      map((res: any) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }
}

